import ProfileInfoRecord from './ProfileInfoRecord.view';

export default ProfileInfoRecord;
